import React from 'react'
import { PlayButton } from './PlayButton';
import MarketingContext from '../../../contexts/MarketingContext';

export const PlayNumber = ({play, group, number}) => {

  let {
          onPlayNumber,
      } = React.useContext(MarketingContext);
 
  return (
   
    <div>
  
     <PlayButton play = {play} onClick={() => {onPlayNumber(group, number)}} label =  {number}/>
        
        
    </div> 

  )
}
  